module.exports = __webpack_public_path__ + "img/cup.bcb26df5.png";